import React, { useEffect, useState } from "react";
import { faCloudArrowUp, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BACKEND_URL } from "../Helpers/constants";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function FileUpload({ setImage, many, images }) {
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    setFiles(Array.from(event.target.files));
  };

  useEffect(() => {
    handleUpload();
  }, [files]);

  const handleUpload = async (e) => {
    if (files.length) {
      const data = new FormData();
      for (let i = 0; i < files.length; i++) {
        data.append("files", files[i]);
        data.append("filenames[]", files[i].name);
      }

      const res = await axios.post(`${BACKEND_URL}/admin/upload`, data);
      if (res.data.status) {
        if (!many) {
          setImage(res.data.data[0]);
        } else {
          setImage(p => {if(p){return [...p, ...res.data.data]}else{return res.data.data}});
        }
      }else{
        toast.error(res.data.message)
      }
    }
  };

  return (
    <div>
        <label htmlFor="file-input"  className={`relative border border-gray-500 rounded-md w-full ${images ? "p-2" : "p-3"} disabled:bg-gray-200 flex items-center`}>
            <p className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" >Պատահարին առնչվող ֆայլեր</p>  
            <FontAwesomeIcon icon={faUpload} className='ml-2'/>
            {images && <p className='ml-8 text-nowrap'>{images?.length + " ֆայլ"}</p>}
        </label>
        <input
            type="file"
            multiple
            id="file-input"
            style={{ display: "none" }}
            onChange={(e) => {
            handleFileChange(e);
            }}
        />
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
